import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    userSignedIn: Boolean,
  };

  connect() {
    this.initializeTheme();
    this.watchSystemTheme();
  }

  initializeTheme() {
    const theme = document.documentElement.dataset.theme;
    this.applyTheme(theme);
  }

  toggle() {
    const isDark = document.documentElement.classList.contains("dark");
    const newTheme = isDark ? "light" : "dark";

    document.documentElement.dataset.theme = newTheme;
    this.applyTheme(newTheme);
    this.saveThemePreference(newTheme);
  }

  applyTheme(theme) {
    if (theme === "system") {
      const systemDark = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;
      document.documentElement.classList.toggle("dark", systemDark);
    } else {
      document.documentElement.classList.toggle("dark", theme === "dark");
    }
  }

  watchSystemTheme() {
    if (document.documentElement.dataset.theme === "system") {
      window
        .matchMedia("(prefers-color-scheme: dark)")
        .addEventListener("change", (e) => this.applyTheme("system"));
    }
  }

  saveThemePreference(theme) {
    if (!this.userSignedInValue) {
      localStorage.setItem("theme", theme);
      return;
    }

    fetch("/profile/update_theme", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
      body: JSON.stringify({ user: { theme } }),
    });
  }
}
